import { render, staticRenderFns } from "./ShareFallbackModal.vue?vue&type=template&id=407b3193&scoped=true&"
import script from "./ShareFallbackModal.vue?vue&type=script&lang=ts&"
export * from "./ShareFallbackModal.vue?vue&type=script&lang=ts&"
import style0 from "./ShareFallbackModal.vue?vue&type=style&index=0&id=407b3193&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407b3193",
  null
  
)

export default component.exports